<template>
    <article class="message">
        <div class="message-body">
            <div class="columns">
                <div class="column is-one-quarter">
                    Total lots found: <strong>{{ totalLotsFound }}</strong>
                </div>
                <div class="column">
                    <div class="field is-grouped is-grouped-multiline">
                        <div v-if="getQueryBrand" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-dark">{{ getQueryBrand }}</span>
                                <span class="tag is-delete is-danger" @click="removeBrandFromQuery"></span>
                            </div>
                        </div>
                        <div v-if="getQueryModels" v-for="name in getQueryModels" class="control">
                            <div class="tags has-addons">
                                <span class="tag is-dark">{{ name }}</span>
                                <span class="tag is-delete is-danger" @click="removeModelFromQuery(name)"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column" style="max-width: 300px;">
                    <div class="field is-horizontal">
                        <div class="field-body">
                            <div class="field">
                                <button v-if="searchSaved" class="button is-warning">
                                    <span class="icon">
                                      <i class="fas fa-star"></i>
                                    </span>
                                    <span>Saved</span>
                                </button>
                                <button v-else="" class="button is-primary" @click="saveFavoriteSearch()">
                                    <span class="icon">
                                      <i class="fas fa-star"></i>
                                    </span>
                                    <span>Favorites</span>
                                </button>
                            </div>
                            <div class="field">
                                <div class="select">
                                    <select v-model="orderColumn" v-on:change="orderBy()">
                                        <option :value="null" disabled hidden>Order by</option>
                                        <option v-for="(column, key) in columns" :value="column.value">{{ column.label }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
    import apiFavoriteSearches from './../../../api/apiFavoriteSearches'
    export default {
        data() {
          return {
              searchSaved: false,
              columns: [
                  {value: 'lot_date', label: 'Date'},
                  {value: 'bid', label: 'Lot#'},
                  {value: 'auction_name', label: 'Auction'},
                  {value: 'company', label: 'Brand'},
                  {value: 'model_name', label: 'Model'},
                  {value: 'mileage_num', label: 'Mileage'},
                  {value: 'model_year_en', label: 'Year'},
                  {value: 'displacement_num', label: 'Displacement'},
                  {value: 'scores', label: 'Score'},
                  {value: 'start_price_en', label: 'Start price'}
              ],
              orderColumn: null
          }
        },
        computed: {
            totalLotsFound () {
                return this.$store.getters.getTotalLots
            },
            getQueryBrand () {
                return this.$store.getters.getQueryCompanyId
            },
            getQueryModels () {
                return this.$store.getters.getQueryModels
            }
        },
        methods: {
            orderBy(){
                this.$store.getters.getResultOrderType === 'ASC' ? this.$store.dispatch('setResultOrderType', 'DESC') : this.$store.dispatch('setResultOrderType', 'ASC')
                this.$store.dispatch('setResultOrderColumn', this.orderColumn)
                this.$store.dispatch('fetchResults')
            },
            removeBrandFromQuery () {
                this.$store.dispatch('changeQueryCompanyId')
                this.$store.dispatch('fetchResults')
            },
            removeModelFromQuery (model) {
                this.$store.dispatch('removeModelFromQuery', model)
                this.$store.dispatch('fetchResults')
            },
            saveFavoriteSearch(){
                let data = { search: this.$store.getters.getQuery }
                apiFavoriteSearches
                    .createFavoriteSearchRequest(data)
                    .then((response) => {
                        this.$store.dispatch('addToFavoriteSearches', response.data)
                        this.searchSaved = true
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Results/SearchOptions.vue